import { render, staticRenderFns } from "./Electrcity.vue?vue&type=template&id=368a1eed&scoped=true&"
import script from "./Electrcity.vue?vue&type=script&lang=js&"
export * from "./Electrcity.vue?vue&type=script&lang=js&"
import style0 from "./Electrcity.vue?vue&type=style&index=0&id=368a1eed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368a1eed",
  null
  
)

export default component.exports